import React from 'react';
import { AuthProvider } from '@dexter-experts/auth-react';
import Routes from './Routes';
import '@dexter-experts/auth-react/styles.css';
import './styles/style.scss';

const authApiUrl = (process.env.REACT_APP_GRAPHQL_BASE_URL || '').replace(/\/graphql\/?$/, '');

function App() {
  return (
    <AuthProvider
      apiUrl={authApiUrl}
      loginRedirectTo="/"
      logoutRedirectTo={window.location.origin}
    >
      <Routes />
    </AuthProvider>
  );
}

export default App;
